var specialProduct1 = false;
var specialProduct2 = false;

for (var i = 0; i < crItems.length; i++ ){
  var itemCollections = crItems[i].collections
  var itemTitle = crItems[i].name;
  if (itemTitle === 'Pickup Instore') continue;
  //console.log({itemTitle})  
  console.log('-->', itemCollections)
 
  if (itemCollections.toLowerCase().indexOf('Cakes'.toLowerCase()) > -1) {
    specialProduct1 = true;
  } 

  if (itemTitle.toLowerCase().indexOf('text on cake'.toLowerCase()) > -1) {
    specialProduct2 = true;
  } 
}

document.addEventListener('crJQActivated', function (e) {
  if (specialProduct1 === false || specialProduct2 === false) {
    jqCR('.extra_input_1_wrapper').remove()
  }
})